// extracted by mini-css-extract-plugin
module.exports = {"wrap":"No","logoContainer":"Oo","brandImg":"Po","logoImg":"Qo","logoButton":"Ro"};